"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HlsVideo = void 0;

var hls_js_1 = __importDefault(require("hls.js"));

var react_1 = __importDefault(require("react"));

var log_1 = require("../log");

var LEVEL_HEIGHTS = [240, 360, 480, 720, 720, 1080, 1080, 1440, 1440, 2160, 2160];
exports.HlsVideo = react_1.default.forwardRef(function (_a, ref) {
  var src = _a.src,
      onLevels = _a.onLevels,
      _a$startLevel = _a.startLevel,
      startLevel = _a$startLevel === void 0 ? 4 : _a$startLevel,
      currentLevel = _a.currentLevel,
      onCurrentLevelChange = _a.onCurrentLevelChange,
      _a$autoLevelBasedOnSi = _a.autoLevelBasedOnSizeCapPadding,
      autoLevelBasedOnSizeCapPadding = _a$autoLevelBasedOnSi === void 0 ? 0 : _a$autoLevelBasedOnSi,
      videoProps = __rest(_a, ["src", "onLevels", "startLevel", "currentLevel", "onCurrentLevelChange", "autoLevelBasedOnSizeCapPadding"]);

  var videoRef = react_1.default.useRef(null);
  var hlsRef = react_1.default.useRef(null);
  react_1.default.useEffect(function () {
    if (currentLevel !== undefined && hlsRef.current) {
      if (hlsRef.current.currentLevel !== currentLevel) {
        hlsRef.current.currentLevel = currentLevel;
      }
    }
  }, [currentLevel]);
  react_1.default.useEffect(function () {
    function _initPlayer() {
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }

      var newHls = new hls_js_1.default({
        abrEwmaDefaultEstimate: 5000000,
        enableWorker: true,
        startLevel: startLevel
      });

      if (videoRef.current) {
        (0, log_1.debug)('attaching to video player');
        newHls.attachMedia(videoRef.current);
      }

      newHls.on(hls_js_1.default.Events.MEDIA_ATTACHED, function () {
        (0, log_1.debug)('loading source');
        newHls.loadSource(src);
        newHls.on(hls_js_1.default.Events.MANIFEST_PARSED, function () {
          if (onLevels) {
            onLevels(newHls.levels);
          }

          if (onCurrentLevelChange) {
            onCurrentLevelChange(newHls.currentLevel);
          }
        });
        newHls.on(hls_js_1.default.Events.LEVEL_SWITCHED, function (event, data) {
          if (onCurrentLevelChange) {
            onCurrentLevelChange(data.level);
          }
        });
      });
      newHls.on(hls_js_1.default.Events.ERROR, function (event, data) {
        (0, log_1.warn)('HLS Error');
        (0, log_1.warn)(data);

        if (data.fatal) {
          switch (data.type) {
            case hls_js_1.default.ErrorTypes.NETWORK_ERROR:
              newHls.startLoad();
              break;

            case hls_js_1.default.ErrorTypes.MEDIA_ERROR:
              newHls.recoverMediaError();
              break;

            default:
              _initPlayer();

              break;
          }
        }
      });
      hlsRef.current = newHls;
    }

    if (hls_js_1.default.isSupported()) {
      _initPlayer();
    }

    var observer = null;

    if (videoRef.current) {
      observer = new ResizeObserver(function (entries) {
        var media = entries[0];

        if ((media === null || media === void 0 ? void 0 : media.contentRect) && hlsRef.current) {
          var height = media.contentRect.height;
          var levelIndex = LEVEL_HEIGHTS.findIndex(function (levelHeight) {
            return levelHeight > height;
          }) + autoLevelBasedOnSizeCapPadding;

          if (LEVEL_HEIGHTS[levelIndex + 1] === LEVEL_HEIGHTS[levelIndex]) {
            levelIndex++; // If there is a 60fps version, use that.
          }

          hlsRef.current.autoLevelCapping = levelIndex;
          (0, log_1.debug)('capping to level %d', levelIndex);
        }
      });
      observer.observe(videoRef.current);
    }

    return function () {
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }

      if (observer) {
        observer.disconnect();
      }
    };
  }, [src, videoRef, autoLevelBasedOnSizeCapPadding]);

  function refHandler(c) {
    videoRef.current = c;

    if (typeof ref === 'function') {
      ref(c);
    } else if (ref) {
      ref.current = c;
    }
  }

  if (hls_js_1.default.isSupported()) return react_1.default.createElement("video", Object.assign({
    ref: refHandler
  }, videoProps));
  return react_1.default.createElement("video", Object.assign({
    ref: refHandler,
    src: src
  }, videoProps));
});